import * as React from 'react';
import { CourseProps } from 'Jsx/Shared/CourseCardV3/types';

import CourseCardV3Wrapper from './CourseCardV3Wrapper';
import {
  Wrapper,
  Image,
  Tag,
  CardBody,
  Title,
  Enrollments,
  Prices,
  BrasilianTag,
  AddToCart,
} from '../components';

const CourseCardBlackFriday: React.FC<CourseProps> = ({ ...props }) => {
  const showBrasilianTag = props.userLanguage === 'pt' && props.languageTag;

  return (
    <CourseCardV3Wrapper
      {...props}
      hideSoftware
      hideScore
      showOnlyAddToCardButton
    >
      <Wrapper>
        <Tag />
        <Image>{showBrasilianTag && <BrasilianTag />}</Image>
        <CardBody>
          <Title />
          <Enrollments />
          <Prices />
          <AddToCart />
        </CardBody>
      </Wrapper>
    </CourseCardV3Wrapper>
  );
};

export default CourseCardBlackFriday;
